import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'variableFilter'
})
export class VariableFilterPipe implements PipeTransform {
  transform(variables: any[], variableName: string): number | string {
    if (!variables || !variableName) {
      return '-'; // Si no hay variables, devuelve '-'
    }
    return variables.find(v => v.name === variableName)?.value || '-';
  }
}